import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchAuxiliaresData } from "../../pages/TabelasAuxiliares/data/fetchAuxiliaresData";
import { Toast } from "../../components/atom/Toast/Toast";

export const useTableData = <TSchema>({
  defaultSchema,
  lookupTable,
  itemSchema,
}: {
  defaultSchema: TSchema;
  lookupTable: Array<{
    name: string;
    entityName: string;
    getParent?: () => Promise<any[]>;
    ParentName?: string;
  }>;
  itemSchema: TSchema;
}) => {
  const [dataTable, setDataTable] = useState<any[]>([]);
  const [originalDataTable, setOriginalDataTable] = useState<any[]>([]);
  const [parentData, setParentData] = useState<any[]>([]);
  const [formSchema, setFormSchema] = useState(defaultSchema);
  const [isLoaded, setIsLoaded] = useState(false);
  const [errorFindingData, setErrorFindingData] = useState(false);
  const { table } = useParams<{ table: string }>();
  const { addToast } = Toast();

  useEffect(() => {
    setErrorFindingData(false);
    const tableIndex = table ? parseInt(table, 10) - 1 : -1;
    if (tableIndex >= 0 && tableIndex < lookupTable.length) {
      const lookupItem = lookupTable[tableIndex];

      if (lookupItem?.getParent) {
        lookupItem.getParent().then((response) => {
          setParentData(response);
          setFormSchema(itemSchema);
        });
      }
      fetchAuxiliaresData(tableIndex, setDataTable, setOriginalDataTable);
      setIsLoaded(true);
    } else {
      addToast({
        status: "error",
        title: "Error",
        description: "Ocorreu um erro ao buscar os dados",
      });
      setErrorFindingData(true);
      console.warn(`Table index ${tableIndex} is out of range.`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [table, lookupTable, itemSchema]);

  return {
    dataTable,
    originalDataTable,
    parentData,
    formSchema,
    isLoaded,
    errorFindingData,
    setDataTable,
    setOriginalDataTable,
  };
};
